import { useBrowserStorage } from 'hooks';

/**
 * Retrieves a voucher code from browser storage (localStorage or sessionStorage).
 *
 * @param key - The storage key to retrieve the voucher from
 * @param persistence - Whether to use localStorage (true) or sessionStorage (false). Defaults to true.
 * @returns The voucher code from storage, or undefined if not found
 *
 * @example
 * // Get voucher from localStorage
 * const code = getVoucherFromBrowserStorage('PIXUM_CART_VOUCHER');
 * // Returns: 'SUMMER2024' (if stored)
 *
 * @example
 * // Get voucher from sessionStorage
 * const code = getVoucherFromBrowserStorage('TEMP_VOUCHER', false);
 * // Returns: 'WELCOME10' (if stored in session)
 *
 * @example
 * // Key not found
 * const code = getVoucherFromBrowserStorage('NON_EXISTENT_KEY');
 * // Returns: undefined
 */
export function getVoucherFromBrowserStorage(
  key: string,
  persistence = true
): string | undefined {
  const { getStorageObject } = useBrowserStorage<string>(persistence);

  return getStorageObject(key);
}
